/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class VirtualMachineRestoreDestination {
  /**
  * The name of the VM to restore
  */
  'vmName'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "vmName",
      "baseName": "vmName",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return VirtualMachineRestoreDestination.attributeTypeMap;
  }

  public constructor() {
  }
}

